import React from 'react'
import { staticContent } from '@src/routes'
import { Link } from '@src/components/Link'
import { makeStyles } from 'tss-react/mui'
import Container from '@mui/material/Container'
import MuiLink from '@mui/material/Link'
import Box from '@mui/material/Box'
import { useUserSession } from '@utils/useUserSession'

const useStyles = makeStyles()((theme) => {
  return {
    root: {
      backgroundColor: '#424242',
      padding: theme.spacing(6, 4),
      textAlign: 'center',
      [theme.breakpoints.up('sm')]: {
        textAlign: 'left',
      },
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
      },
    },
    copyright: {
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.common.white,
      lineHeight: 1.7,
      marginBottom: theme.spacing(6),
      '& b': {
        fontWeight: theme.typography.fontWeightBold,
      },
      [theme.breakpoints.up('sm')]: {
        marginBottom: 0,
        marginRight: theme.spacing(12),
      },
    },
    textLink: {
      color: theme.palette.common.white,
      '&:hover': {
        color: theme.palette.common.white,
      },
    },
    noWrap: { whiteSpace: 'nowrap' },
    socialLink: {
      height: 32,
      margin: theme.spacing(0, 3),
      opacity: 0.8,
      transition: 'all .2s',
      '&:hover': {
        opacity: 0.9,
      },
      [theme.breakpoints.up('sm')]: {
        height: 28,
        margin: theme.spacing(0, 2),
      },
    },
    icpLink: {
      display: 'inline-flex',
      alignItems: 'center',
      '& img': {
        marginLeft: theme.spacing(1),
        height: 14,
        width: 14,
      },
    },
  }
})
const LegacyFooter = () => {
  const { classes, cx } = useStyles()
  const { userSession } = useUserSession()
  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.content}>
          <div className={classes.copyright}>
            <Box component="p" m={0}>
              <b>
                © 2021 Merck KGaA, Darmstadt, Germany and/or its affiliates.
              </b>{' '}
              <span>
                保留所有权利。严格禁止在未经同意的情况下转载本网站之所有信息。
                Sigma-Aldrich品牌产品均由Sigma-Aldrich LLC.独家贩售。
                <MuiLink
                  href="https://beian.miit.gov.cn/"
                  target="_blank"
                  className={cx(classes.textLink, classes.noWrap)}
                >
                  沪ICP备14038167号-3
                </MuiLink>
                .
              </span>
              <Box component="span" ml={2} mr={2} position="relative" top={-1}>
                |
              </Box>
              <MuiLink
                href="/assets/documents/hazardous-chemicals.pdf"
                target="_blank"
                className={classes.textLink}
              >
                危险化学品经营许可证
              </MuiLink>
              <Box component="span" ml={2} mr={2} position="relative" top={-1}>
                |
              </Box>
              <MuiLink
                href="/static/toxic_chemical_license.png"
                target="_blank"
                className={classes.textLink}
              >
                剧毒化学品购买凭证
              </MuiLink>
              <Box component="span" ml={2} mr={2} position="relative" top={-1}>
                |
              </Box>
              <Link
                {...staticContent.index({
                  path: '/terms-and-conditions',
                  language: userSession.language,
                  country: userSession.country,
                })}
                passHref
              >
                <MuiLink className={cx(classes.textLink, classes.noWrap)}>
                  使用条款
                </MuiLink>
              </Link>
              <Box component="span" ml={2} mr={2} position="relative" top={-1}>
                |
              </Box>
              <Link
                {...staticContent.index({
                  path: '/privacy-policy',
                  language: userSession.language,
                  country: userSession.country,
                })}
                passHref
              >
                <MuiLink className={classes.textLink}>隐私权原则</MuiLink>
              </Link>
              <Box component="span" ml={2} mr={2} position="relative" top={-1}>
                |
              </Box>
              <MuiLink
                color="inherit"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502009568"
                target="_blank"
                className={cx(classes.icpLink, classes.textLink)}
              >
                沪公网安备 31011502009568号
                <img alt="icp icon" src="/static/icp_logo_icon.png" />
              </MuiLink>
            </Box>
          </div>
          <Box display="flex">
            <Box display="flex" alignItems="center">
              <a href="/news/wechat-official-account">
                <img
                  src="/assets/images/wechat-logo-white/wechat-logo-white.svg"
                  alt=""
                  className={classes.socialLink}
                />
              </a>
            </Box>
            <Box display="flex" alignItems="center">
              <a
                href="https://www.zhihu.com/org/mo-ke-sheng-ming-ke-xue/activities"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                <img
                  src="/assets/images/weibo-logo-white/weibo-logo-white.svg"
                  alt=""
                  className={classes.socialLink}
                />
              </a>
            </Box>
            <Box display="flex" alignItems="center">
              <a
                href="https://www.linkedin.com/groups/?gid=21076"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                <img
                  src="/assets/images/linkedin-logo-white/linkedin-logo-white.svg"
                  alt=""
                  className={classes.socialLink}
                />
              </a>
            </Box>
          </Box>
        </div>
      </Container>
    </div>
  )
}

export default LegacyFooter
